<template>
  <ModalBase v-bind="$attrs" v-on="$listeners" @change:modal="onChangeModal">
    <div slot="content">
      <h1>{{ lang.title }}</h1>
      <v-select v-model="category" :items="this.getCategories()" item-text="name" item-value="id"></v-select>
      <v-select v-model="topic" :items="topics" item-text="name" item-value="id"></v-select>
      <div class="text-xs-center">
        <Button :text="lang.okButton" color="success" :handleClick="onSuccessButtonClick"></Button>
        <Button :text="lang.cancel" color="primary" :handleClick="onButtonClick"></Button>
      </div>
    </div>
  </ModalBase>
</template>

<script>
import { mapState } from "vuex";

import ModalBase from "./ModalBase";
import Button from "./Button";

export default {
  inheritAttrs: false,
  components: {
    ModalBase,
    Button
  },
  data() {
    return {
      topics: [],
      category: null,
      topic: null,
    };
  },
  computed: {
    ...mapState({
      employee: state => state.employee.employee,
      states: state => state.employee,
    }),
    lang() {
      return {
        title: this.$t(window.Vocabulary.selectTrainingTopic),
        cancel: this.$t(window.Vocabulary.cancel),
        okButton: "Ok"
      };
    }
  },
  methods: {
    getCategories() {
      let categories = [];

      if (this.states.trainingTopics) {
        Object.entries(this.states.trainingTopics).forEach(([id, cat]) => {
          categories.push({id:id, name: cat.name});
        })
      }
      
      return categories;
    },
    onButtonClick() {
      this.$emit("cancel", true);
    },
    onSuccessButtonClick() {
      if (this.topic) {
          this.$emit("confirm", {
            trainingTopic: this.topic
          });
      }
    },
    onChangeModal(val) {
      if (!val) {
        this.onButtonClick();
      }
    },
    onSelectCategory(value) {
      if (value) {
        this.topics = this.states.trainingTopics[value].items;
      } else {
        this.topics = [];
      }
    }
  },
  watch: {
    category: {
      // immediate: true,
      handler: 'onSelectCategory'
    }
    // topic: {
    //   immediate: true,
    //   handler: 'onSelectTopic'
    // }
  }
};
</script>

<style lang="scss" scoped>
</style>